import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/opendeur.webp';
import screenshot_target from '../../../images/letterfunnel/floristenhove.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Floris ten Hove"
      firstname="Floris"
      companyname="OpenDeur"
      competition="Makelaarsland en Ten Hag Makelaars"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/floristenhove.js